import { Icons } from '../assets/Icons';

export const getLogoByBrand = (brandId: string): React.ReactNode => {
  return Icons[brandId] || null;
};
